import { render, staticRenderFns } from "./WxEditor.vue?vue&type=template&id=5a0d7337&"
import script from "./WxEditor.vue?vue&type=script&lang=js&"
export * from "./WxEditor.vue?vue&type=script&lang=js&"
import style0 from "./WxEditor.vue?vue&type=style&index=0&id=5a0d7337&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a0d7337')) {
      api.createRecord('5a0d7337', component.options)
    } else {
      api.reload('5a0d7337', component.options)
    }
    module.hot.accept("./WxEditor.vue?vue&type=template&id=5a0d7337&", function () {
      api.rerender('5a0d7337', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wechat/WxEditor.vue"
export default component.exports